module.exports = __webpack_public_path__ + "static/media/large_literary_art.e8d64193.jpg";